// PLEASE REMOVE THIS FILE ONCE THE NEW CHECKOUT SCREEN IS IMPLEMENTED
import { useDispatch } from "react-redux";
import { parse } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";

import { actionCreators as postcodeAction } from "../../store/postcodes/actions";
import { actionCreators as therapistAction } from "../../store/therapists/actions";
import { actionCreators as treatmentAction } from "../../store/treatments/actions";
import { AddedTreatment } from "../../components/themed-v2/pages/therapist-detail-page/hooks/use-handle-treatments";
import { Therapist } from "../../components/themed-v2/pages/therapist-detail-page/types";
import { config } from "../../config";
import { IServiceTreatment, ITherapist } from "../../services/api/therapists";
import { ApiAddress } from "../../services/api/addresses";

type PushCheckoutStates = (params: {
  dispatch: ReturnType<typeof useDispatch>;
  therapist?: Therapist;
  postcode: string;
  date: string;
  time: string;
  selectedTreatments: AddedTreatment;
}) => void;

export const pushCheckoutStates: PushCheckoutStates = ({
  dispatch,
  therapist,
  postcode,
  date,
  time,
  selectedTreatments,
}) => {
  if (!therapist) {
    return;
  }

  const bookingDate = zonedTimeToUtc(
    parse(`${date} ${time}`, "yyyy-MM-dd HH:mm", new Date()),
    config.dateTime.timezone,
  );

  dispatch(postcodeAction.setSelectedPostcode(postcode));
  dispatch(therapistAction.selectTherapist({
    urn: `${therapist.urn}${
      typeof therapist.workstation !== "undefined" 
      ? `-${therapist.workstation}` 
      : ""
    }`,
    name: therapist.displayName,
    therapistName: therapist.displayName,
    logoImage: therapist.avatarImageUrl,
  } as ITherapist));
  dispatch(therapistAction.setDate(bookingDate.toISOString()));

  const treatments: { [urn: string]: IServiceTreatment } = {};

  for (const item of therapist.treatments) {
    const { price } = item.merchandisingPrice;
    const { 
      urn,
      name,
      description,
      duration,
      categories,
    } = item.treatment;

    if (urn in selectedTreatments) {
      const count = selectedTreatments[urn];
      treatments[urn] = {
        urn,
        price,
        name,
        duration,
        description,
        count, 
        category: categories[0]?.name ?? "",
      };
    }
  }

  dispatch(treatmentAction.setTreatments(treatments));
};

export const pushAddressState = (
  dispatch: ReturnType<typeof useDispatch>,
  {postcode, address1, address2}: ApiAddress,
): void => {
  const data = {
    postcode, 
    line_1: address1 || "",
    line_2: address2 || "",    
  };

  dispatch(postcodeAction.setAddressManually(data));
  dispatch(postcodeAction.setBillingAddressManually(data));
};